const configValues = {
  api: {
    url: import.meta.env.API_BASE_URL,
  },
  app: {
    name: import.meta.env.APP_NAME,
    env: import.meta.env.APP_ENV,
    state: import.meta.env.STATE,
    isDev: import.meta.env.STATE === 'dev',
    version: import.meta.env.APP_VERSION,
  },
  oauth: {
    grant_type: import.meta.env.OAUTH_GRANT_TYPE,
    client_id: import.meta.env.OAUTH_CLIENT_ID,
    client_secret: import.meta.env.OAUTH_CLIENT_SECRET,
  },
  gql: {
    url: import.meta.env.GRAPHQL_URL,
    client_id: import.meta.env.GQL_OAUTH_CLIENT_ID,
    client_secret: import.meta.env.GQL_OAUTH_CLIENT_SECRET,
  },
  websockets: {
    url: import.meta.env.WEBSOCKETS_SERVER,
    key: import.meta.env.WEBSOCKETS_KEY,
  },
  services: {
    github: {
      sha:  import.meta.env.GITHUB_SHA
    },
    cloudfront: {
      thumbnailUrl: import.meta.env.CLOUDFRONT_THUMBNAIL_URL,
      // Base del CDN para reescribir rutas relativas de fotos-addon (mismo env que el backend
      // CLOUDFRONT_URL_ACTUAL). El default lo aplica el consumidor (addonImageUrl).
      url: import.meta.env.CLOUDFRONT_URL_ACTUAL,
      pages: import.meta.env.CF_PAGES
    },
    firebase: {
      apiKey: import.meta.env.GOOGLE_API_FIREBASE_KEY,
    },
    googleMaps: {
      apiKey: import.meta.env.GOOGLE_API_MAPS_KEY,
    },
    sentry: {
      sha: import.meta.env.COMMIT_REF || import.meta.env.GITHUB_SHA,
    },
    aws: {
      url: import.meta.env.AWS_URL,
    },
    ozaru: {
      url: import.meta.env.OZARU_URL,
    },
  },
}

/* Get config value by key including nested values */
export const config = (key, defaultValue) => {
  const keys = key.split('.')
  
  let value = configValues

  keys.forEach((k) => {
    value = value[k]
  })
  return value ? value : defaultValue
}
